import { env } from "../../env/env";
import { DesignProduct } from "../../util/Products";

export interface DesignProductCardProps {
  product: DesignProduct;
}

export default function DesignProductCard({ product }: DesignProductCardProps) {
  return (
    <li>
      <a href={env.timberContextPath + "/design?size=" + product.key}>
        <h6>{product.name}</h6>
        <img
          loading="lazy"
          src={product.img}
          alt={product.name}
        />
      </a>
    </li>
  );
}
